module.exports = __webpack_public_path__ + "static/media/screen4.4571a407.png";